// proxy to have access to Redux Store from any part of React App.
let store;
export const setStore = (s) => {
    store = s;
};
export const getStore = () => store;
